module.exports = __webpack_public_path__ + "img/6.6dc819cc.jpg";